module.exports = __webpack_public_path__ + "img/Technology Partner-1.a7858c2b.png";